module.exports = __webpack_public_path__ + "img/ZAF.ec639373.gif";